import { Box, Container, Grid, GridItem, Image, Text } from "@chakra-ui/react";
import { landingPageConstants } from "common/landingPageConstants";
import VaultIcon from "common/assets/img/Vault.png";
import PasswordIcon from "common/assets/img/Password.png";
import PassImg from "common/assets/img/passScreenshot.png";
import Shieldcheck from "common/assets/img/Shieldcheck.png";
import ClipIcon from "common/assets/img/Clip.png";
import SubtitleIcon from "common/assets/img/subtitleIcon.png";

const passwordFeatures = [
  {
    icon: VaultIcon,
    title: "Store & manage personal credentials",
    description: "Safely save all your logins in one encrypted vault.",
  },
  {
    icon: PasswordIcon,
    title: "Share passwords safely with team",
    description: "Collaborate without exposing sensitive info.",
  },
  {
    icon: Shieldcheck,
    title: "Control access with role permissions",
    description: "Set who can view, edit, or share credentials.",
  },
  {
    icon: ClipIcon,
    title: "Categorize, tag & audit shared data",
    description: "Organize credentials and track activity.",
  },
];

const PasswordManagementSection = () => {
  return (
    <>
      <Container maxW="container.xl">
        <Box className="passwordSection">
          <Box className="sectionTitlebox">
            <Text className="iconSubtitle">
              {" "}
              <Image
                src={SubtitleIcon}
                height={"16px"}
                width={"16px"}
                alt=""
              />{" "}
              Password
            </Text>

            <Text className="sectionTitle">
              {landingPageConstants.passwordTitle}
            </Text>
            <Text className="sectionDesc">
              {landingPageConstants.passwordDesc}
            </Text>
          </Box>
          <Grid
            templateColumns="repeat(3, 1fr)"
            display="flex"
            gap={{base: "30px", md: "30px", lg: "0px"}}
            alignItems="center"
            mt="64px"
            justifyContent="space-between"
            flexDirection={{base: "column", md: "row", lg: "row"}}
          >
            <GridItem colSpan={{base:3,md:1,lg:1}} width={{base: "100%", md: "288px", lg: "288px"}}>
              {passwordFeatures.slice(0, 2).map((item, idx) => (
                <Box className="passManageBox" mb={6} key={idx}>
                  <Box className="passManageImg">
                    <Image src={item.icon} height="32px" width="32px" alt="" />
                  </Box>
                  <Box className="passManageCont">
                    <Text className="passManageTitle">{item.title}</Text>
                    <Text className="passManageDesc">{item.description}</Text>
                  </Box>
                </Box>
              ))}
            </GridItem>

            <GridItem colSpan={{base:3,md:1,lg:1}} width={{base: "100%", md: "392px", lg: "392px"}}>
              <Box className="passwordViewImage">
                <Image
                  src={PassImg}
                  alt="Password Management"
                  width="100%"
                  height="auto"
                  borderRadius="16px"
                />
              </Box>
            </GridItem>

            <GridItem colSpan={{base:3,md:1,lg:1}} width={{base: "100%", md: "288px", lg: "288px"}}>
              {passwordFeatures.slice(2).map((item, idx) => (
                <Box className="passManageBox" mb={6} key={idx}>
                  <Box className="passManageImg">
                    <Image src={item.icon} height="32px" width="32px" alt="" />
                  </Box>
                  <Box className="passManageCont">
                    <Text className="passManageTitle">{item.title}</Text>
                    <Text className="passManageDesc">{item.description}</Text>
                  </Box>
                </Box>
              ))}
            </GridItem>
          </Grid>
        </Box>
      </Container>
    </>
  );
};
export default PasswordManagementSection;
